module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isReady),
      expression: "isReady"
    }],
    attrs: {
      "id": "app",
      "element-loading-text": (!_vm.installed) ? 'A descarregar...' : 'A actualizar...'
    }
  }, [_c('el-row', {
    staticClass: "container",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "stripe"
  }, [_c('img', {
    attrs: {
      "src": "static/img/stripe.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.svg"
    }
  })])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container",
    attrs: {
      "id": "info"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "out-in"
    }
  }, [(!_vm.home) ? _c('el-button', {
    attrs: {
      "id": "back",
      "type": "primary",
      "size": "small",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Voltar")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ghost"
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "uppercase",
    attrs: {
      "span": 16,
      "offset": 1
    }
  }, [_vm._v("Lisboa "), _c('a', {
    attrs: {
      "href": "tel:+351219349490"
    }
  }, [_vm._v("219 349 490")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.update
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 21 21",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.553 3.428C15.747 1.615 13.253.49 10.49.49 4.965.49.503 4.965.503 10.49s4.462 10 9.987 10c4.657 0 8.557-3.187 9.663-7.5h-2.6c-1.03 2.913-3.794 5-7.063 5-4.143 0-7.5-3.356-7.5-7.5 0-4.143 3.357-7.5 7.5-7.5 2.07 0 3.925.863 5.282 2.22L11.74 9.24h8.75V.49l-2.937 2.938z",
      "fill": "#F2F2F2"
    }
  }), _c('path', {
    attrs: {
      "d": "M-4.51-4.51h30v30h-30"
    }
  })])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc235ee6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 143
// module chunks = 1